var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconSize } from './Icon.enum';
const BaseIcon = styled.svg `
  display: flex;
  flex-direction: row;
  justify-content: center;
  stroke: ${({ stroke }) => stroke};
  stroke-width: ${({ strokeWidth }) => strokeWidth};
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
`;
const Icon = (_a) => {
    var { color, name, size, className } = _a, delegated = __rest(_a, ["color", "name", "size", "className"]);
    const [iconSrc, setIconSrc] = useState('');
    const iconSize = size || IconSize.SIZE24;
    useEffect(() => {
        var _a;
        setIconSrc(((_a = document.getElementById('iconSprites')) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) || '');
    }, []);
    return (_jsx(BaseIcon, Object.assign({ className: className, style: { color: color || 'currentColor' } }, delegated, { height: iconSize, viewBox: `0 0 ${iconSize} ${iconSize}`, width: iconSize }, { children: _jsx("use", { xlinkHref: `${iconSrc}#icon_${name}` }, void 0) }), void 0));
};
export default Icon;
//# sourceMappingURL=Icon.js.map